import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";

import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "features/Application/slices/createFetchingItemsSlice";
import type { PayloadAction } from "@reduxjs/toolkit";
import { type GroupAvailableUsers } from "../../../../types";

export interface GroupMembersAssignmentState extends FetchingItemsState<GroupAvailableUsers> {
  selectedIds: number[];
}

export const initialState: GroupMembersAssignmentState = {
  items: [],
  itemsCount: 0,
  selectedIds: [],
  isLoading: false,
  error: undefined,
};

const groupMembersAssignmentSlice = createFetchingItemsSlice({
  initialState,
  namePayload: {
    namespace: ReducerNamespaceTypes.People,
    entity: ReducerEntityPrefixTypes.AddGroup,
    name: "assignment",
  },
  reducers: {
    selectedItemsChanged: (state, action: PayloadAction<number[]>) => {
      state.selectedIds = action.payload;
    },
    resetSelectedItems(state) {
      state.selectedIds = [];
    },
  },
});

export const { fetchBegin, fetchSuccess, fetchFailure, selectedItemsChanged, resetSelectedItems, reset } =
  groupMembersAssignmentSlice.actions;

export default groupMembersAssignmentSlice.reducer;
